<template>
    
    <div class="swiper-container" id="ShipSlider">

        <div class="swiper-wrapper">
            <slot></slot>
        </div>

        <div class="controls">
            <p class="caption"></p>
            <div></div>
            <div class="wrap-pagination">
                <div class="swiper-pagination"></div>
                <div class="swiper-arrows">
                    <div class="button-prev btn-prev"></div>
                    <div></div>
                    <div class="button-next btn-next"></div>
                </div>
            </div>
        </div>

    </div>
    
</template>

<script>
    import $ from 'jquery';
    import Swiper from 'swiper';
    import {debounce} from 'lodash';
    export default {
        props: {

        },
        data() {
            return {
                swiperShip: null,
                numbreOfSlide: 0
            };
        },
        computed:{

        },
        methods: {
            initSwiper(){

                // Init
                this.swiperShip = new Swiper ('#ShipSlider',{
                    effect: "fade",
                    autoHeight: true,
                    threshold: 40,
                    speed: 300,
                    virtualTranslate: true,
                    grabCursor: true,
                    navigation: {
                        nextEl: '#ShipSlider .button-next',
                        prevEl: '#ShipSlider .button-prev',
                    },
                    pagination: {
                        el: '#ShipSlider .swiper-pagination',
                        type: 'fraction',
                        renderFraction: function (currentClass, totalClass) {
                            return '<span class="' + currentClass + '"></span>' +
                                    '<span class="' + totalClass + '"></span>';
                        },
                        formatFractionCurrent: function (number) {
                            return ("0" + number).slice(-2)
                        },
                        formatFractionTotal: function (number) {
                            return ("0" + number).slice(-2)
                        },

                    },


                })

                this.numbreOfSlide = this.swiperShip.slides.length

                this.swiperShip.on('slideNextTransitionStart slidePrevTransitionStart', ()=> {
                    this.clearPagination()
                    this.changeCaption()
                });
                this.changeCaption()
                this.clearPagination()

            },
            clearPagination(){

                // Efface le bouton Suivant en fin de course
                if(this.swiperShip.activeIndex == (this.numbreOfSlide - 1)){
                    $('#ShipSlider .button-next').addClass('disabled')
                }else{
                    $('#ShipSlider .button-next').removeClass('disabled')
                }

                // Efface le bouton Précedent en début de course
                if(this.swiperShip.activeIndex == 0){
                    $('#ShipSlider .button-prev').addClass('disabled')
                }else{
                    $('#ShipSlider .button-prev').removeClass('disabled')
                }

            },
            changeCaption: debounce(function () {
                $('#ShipSlider p.caption').hide().html($('#ShipSlider .swiper-slide-active img').attr( 'alt' )).fadeIn(1000)
            }, 500),

        },
        mounted() {
            this.initSwiper()


        },
        created() {
            
        },
        destroyed() {
            
        },
    }
</script>




// WEBPACK FOOTER //
// assets/js/components/ship/ShipCarousel.vue